function addGlobalEventListener(
  type,
  selector,
  cb,
  options,
  parent = document
) {
  parent.addEventListener(
    type,
    (e) => {
      if (e.target.matches(selector)) {
        e.preventDefault();
        cb(e.target);
      } else {
        let el = e.target.closest(selector);

        if (el) {
          e.preventDefault();
          cb(el);
        }
      }
    },
    options
  );
}
addGlobalEventListener('click', '#section-ternary-project a', function (e) {
  var lisName = document.title.split(' –')[0]
      if(lisName == "All"){
        lisName = "Shop";
      }
  sessionStorage.setItem('listName', "Projects");
  sessionStorage.setItem('discover', 'true');
  sessionStorage.setItem('collection-title', "Projects");
  sessionStorage.setItem('collection-id', meta.page.resourceId);
  sessionStorage.setItem('collection-index', 0);
  window.location.href = e.href;
 
});

   addGlobalEventListener('click', 'section#section-biodynamic-project a', function (e) {
  var lisName = document.title.split(' –')[0]
      if(lisName == "All"){
        lisName = "Shop";
      }
  sessionStorage.setItem('listName', "Projects");
  sessionStorage.setItem('discover', 'true');
  sessionStorage.setItem('collection-title', "Projects");
  sessionStorage.setItem('collection-id', meta.page.resourceId);
  sessionStorage.setItem('collection-index', 1);
  window.location.href = e.href;
 
});
